module.exports = __webpack_public_path__ + "b23b0ce10f5b1ac19f58f3cb706873fd.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-user/details/manage-user-details.html
// module id = 1990
// module chunks = 0